import { render, staticRenderFns } from "./viewranking.vue?vue&type=template&id=ad9cbb50&scoped=true"
import script from "./viewranking.vue?vue&type=script&lang=js"
export * from "./viewranking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9cbb50",
  null
  
)

export default component.exports